<template>
  <div class="main">
    <el-container class="main-content">
      <el-aside :width="isCollapse ? '60px' : '210px'">
        <AdminMenu :collapse="isCollapse" />
      </el-aside>
      <el-container class="page">
        <el-header class="page-header">
          <AdminHeader @foldChange="handleFoldChange" />
        </el-header>
        <el-main class="page-content">
          <!-- 标签导航栏 -->
          <AdminTagList></AdminTagList>

          <div class="page-info">
            <!-- 主内容（根据路由动态展示不同页面） -->
            <router-view v-slot="{ Component }">
              <Transition name="fade">
                <!-- max 指定最多缓存 10 个组件；Component 为 null 时避免 renderSlot 报错 -->
                <KeepAlive v-if="Component" :max="10">
                  <component :is="Component"></component>
                </KeepAlive>
              </Transition>
            </router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AdminMenu from 'components/admin/admin-menu.vue'
import AdminHeader from 'components/admin/admin-header.vue'
import AdminTagList from 'components/admin/admin-tag-list.vue'
import { useStore } from '@/store'

const isCollapse = ref(false)
const store = useStore()
store.commit('changeCollapse', isCollapse.value)
const handleFoldChange = (isFold: boolean) => {
  isCollapse.value = isFold
  store.commit('changeCollapse', isCollapse.value)
}
</script>

<style scoped lang="less">
.main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.main-content,
.page {
  height: 100%;
}

.page-content {
  height: calc(100% - 48px);

  .page-info {
    background-color: #fff;
    border-radius: 5px;
  }
}
.el-footer {
  display: flex;
  color: #333;
  text-align: center;
  align-items: center;
}

.el-aside {
  overflow-x: hidden;
  overflow-y: auto;
  line-height: 200px;
  text-align: left;
  cursor: pointer;
  background-color: #001529;
  transition: width 0.3s linear;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */

  &::-webkit-scrollbar {
    display: none;
  }
}
.page-header {
  padding-left: var(--el-header-padding);
}

.el-main {
  color: #333;
  text-align: center;
  background-color: #f0f2f5;
}
</style>
